import { ScheduleService } from "../fhir/ScheduleService";
import { SupportedActorType } from "../fhir/fhir.types";
import { ScheduleSummary } from "./Scheduling.types";
import { mapScheduleSummary } from "./scheduling.mappers";

export class ScheduleDirectoryService {
  constructor(private readonly scheduleService: ScheduleService) {}

  async search(
    actorType: SupportedActorType,
    query: string,
  ): Promise<ScheduleSummary[]> {
    const schedules = await this.scheduleService.searchDirectory(
      actorType,
      query,
    );

    return schedules
      .map(mapScheduleSummary)
      .sort((left, right) => left.title.localeCompare(right.title));
  }

  async getById(id: string): Promise<ScheduleSummary | undefined> {
    const schedule = await this.scheduleService.getById(id);
    return schedule ? mapScheduleSummary(schedule) : undefined;
  }
}
